import React from "react";
import { Card, Button, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./BlogCard.css"; // For custom hover styles

const BlogCard = ({ title, description, imageUrl, blogId, author, date, tags, slug }) => {
  const truncatedDescription = description
    ? description.slice(0, 100)
    : "No description available.";

  const formattedDate = Array.isArray(date)
    ? `${date[2].toString().padStart(2, "0")}-${date[1].toString().padStart(2, "0")}-${date[0]}`
    : "Unknown Date";

  const tagList = tags
    ? tags.split(",").map((tag, idx) => (
        <Badge bg="light" text="dark" key={idx} className="me-1 mb-1 border">
          #{tag.trim()}
        </Badge>
      ))
    : null;

  return (
    <Card className="mb-4 shadow-sm h-100 blog-card border-0 w-100">
      <Card.Img
        variant="top"
        src={imageUrl}
        alt={title}
        className="card-img-top"
        style={{ height: "200px", objectFit: "cover" }}
      />
      <Card.Body className="d-flex flex-column p-3">
        <Card.Title className="blog-title mb-2 text-truncate">{title}</Card.Title>
        <Card.Subtitle className="mb-2 text-muted" style={{ fontSize: "0.85rem" }}>
          By {author || "Unknown Author"} on {formattedDate}
        </Card.Subtitle>
        <Card.Text className="flex-grow-1" style={{ fontSize: "0.95rem" }}>
          {truncatedDescription}...
        </Card.Text>
        <div className="mb-2">{tagList}</div>
        <div className="mt-auto">
          <Link to={`${blogId}/${slug}`} >
            <Button variant="primary" size="sm" className="btn-lg btn-block w-100">
              Read More
            </Button>
          </Link>  
        </div>
      </Card.Body>
    </Card>
  );
};

export default BlogCard;
